// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupDropDown-container .Dropdown-root {
  position: relative;
}

.popupDropDown-container .Dropdown-control {
  width: 120px;
  height: 30px;
  position: relative;
  box-sizing: border-box;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #275ce6;
  font-size: 14px;
  font-weight: 400;
  color: #275ce6;
  cursor: default;
  outline: none;
  padding: 0px;
  transition: all 200ms ease;
}

.popupDropDown-container .Dropdown-arrow {
  content: " ";
  display: block;
  height: 0;
  margin-top: -ceil(2.5);
  position: absolute;
  right: 10px;
  top: 8.5px;
  width: 0;
  border: solid #275ce6;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.popupDropDown-container .is-open .Dropdown-arrow {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.popupDropDown-container .Dropdown-menu {
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  margin-top: -1px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  top: 100%;
  width: initial;
  overflow-wrap: break-word;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
  text-align: left;
}

.popupDropDown-container .Dropdown-menu .Dropdown-group > .Dropdown-title {
  padding: 8px 10px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  text-transform: capitalize;
}

.popupDropDown-container .Dropdown-option {
  box-sizing: border-box;
  color: rgba(51, 51, 51, 0.8);
  cursor: pointer;
  display: block;
  padding: 8px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popupDropDown-container .Dropdown-option:last-child {
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}

.popupDropDown-container .Dropdown-option:hover {
  background-color: #f2f9fc;
  color: #333;
}

.popupDropDown-container .Dropdown-option.is-selected {
  background-color: #f2f9fc;
  color: #333;
}

.popupDropDown-container .Dropdown-noresults {
  box-sizing: border-box;
  color: #ccc;
  cursor: default;
  display: block;
  padding: 8px 10px;
}

.popupDropDown-container .Dropdown-placeholder {
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px;
  margin-left: 0px;
}

.bsaDropDownMobile .Dropdown-root {
  position: relative;
}

.bsaDropDownMobile .Dropdown-control {
  width: 120px;
  height: 30px;
  position: relative;
  box-sizing: border-box;
  border: none;
  border-radius: 0;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  cursor: default;
  outline: none;
  padding-left: 6px;
  transition: all 200ms ease;
}

.bsaDropDownMobile .arrow-closed,
.arrow-open {
  content: " ";
  display: block;
  height: 0;
  margin-top: -ceil(2.5);
  position: absolute;
  right: 4px;
  top: 6.5px;
  width: 0;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.bsaDropDownMobile .arrow-open {
  content: " ";
  display: block;
  height: 0;
  margin-top: -ceil(2.5);
  position: absolute;
  right: 4px;
  top: 9.5px;
  width: 0;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(225deg);
  -webkit-transform: rotate(225deg);
}

.bsaDropDownMobile .Dropdown-menu {
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  margin-top: -1px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  /* top:100%; */
  width: initial;
  overflow-wrap: break-word;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
  text-align: left;
}

.bsaDropDownMobile .Dropdown-menu .Dropdown-group > .Dropdown-title {
  padding: 8px 10px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  text-transform: capitalize;
}

.bsaDropDownMobile .Dropdown-option {
  box-sizing: border-box;
  color: rgba(51, 51, 51, 0.8);
  cursor: pointer;
  display: block;
  padding: 8px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bsaDropDownMobile .Dropdown-option:last-child {
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}

.bsaDropDownMobile .Dropdown-option:hover {
  background-color: #f2f9fc;
  color: #333;
}

.bsaDropDownMobile .Dropdown-option.is-selected {
  background-color: #f2f9fc;
  color: #333;
}

.bsaDropDownMobile .Dropdown-noresults {
  box-sizing: border-box;
  color: #ccc;
  cursor: default;
  display: block;
  padding: 8px 10px;
}

.bsaDropDownMobile .Dropdown-placeholder {
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px;
  margin-left: 0px;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/dropDown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uCAAuC;EACvC,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uCAAuC;EACvC,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".popupDropDown-container .Dropdown-root {\n  position: relative;\n}\n\n.popupDropDown-container .Dropdown-control {\n  width: 120px;\n  height: 30px;\n  position: relative;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 0;\n  border-bottom: 1px solid #275ce6;\n  font-size: 14px;\n  font-weight: 400;\n  color: #275ce6;\n  cursor: default;\n  outline: none;\n  padding: 0px;\n  transition: all 200ms ease;\n}\n\n.popupDropDown-container .Dropdown-arrow {\n  content: \" \";\n  display: block;\n  height: 0;\n  margin-top: -ceil(2.5);\n  position: absolute;\n  right: 10px;\n  top: 8.5px;\n  width: 0;\n  border: solid #275ce6;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 3px;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n\n.popupDropDown-container .is-open .Dropdown-arrow {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n\n.popupDropDown-container .Dropdown-menu {\n  background-color: white;\n  border: 1px solid #ccc;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  top: 100%;\n  width: initial;\n  overflow-wrap: break-word;\n  z-index: 1000;\n  -webkit-overflow-scrolling: touch;\n  text-align: left;\n}\n\n.popupDropDown-container .Dropdown-menu .Dropdown-group > .Dropdown-title {\n  padding: 8px 10px;\n  color: rgba(51, 51, 51, 1);\n  font-weight: bold;\n  text-transform: capitalize;\n}\n\n.popupDropDown-container .Dropdown-option {\n  box-sizing: border-box;\n  color: rgba(51, 51, 51, 0.8);\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.popupDropDown-container .Dropdown-option:last-child {\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.popupDropDown-container .Dropdown-option:hover {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.popupDropDown-container .Dropdown-option.is-selected {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.popupDropDown-container .Dropdown-noresults {\n  box-sizing: border-box;\n  color: #ccc;\n  cursor: default;\n  display: block;\n  padding: 8px 10px;\n}\n\n.popupDropDown-container .Dropdown-placeholder {\n  height: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100px;\n  margin-left: 0px;\n}\n\n.bsaDropDownMobile .Dropdown-root {\n  position: relative;\n}\n\n.bsaDropDownMobile .Dropdown-control {\n  width: 120px;\n  height: 30px;\n  position: relative;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: #fff;\n  cursor: default;\n  outline: none;\n  padding-left: 6px;\n  transition: all 200ms ease;\n}\n\n.bsaDropDownMobile .arrow-closed,\n.arrow-open {\n  content: \" \";\n  display: block;\n  height: 0;\n  margin-top: -ceil(2.5);\n  position: absolute;\n  right: 4px;\n  top: 6.5px;\n  width: 0;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 3px;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n.bsaDropDownMobile .arrow-open {\n  content: \" \";\n  display: block;\n  height: 0;\n  margin-top: -ceil(2.5);\n  position: absolute;\n  right: 4px;\n  top: 9.5px;\n  width: 0;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 3px;\n  transform: rotate(225deg);\n  -webkit-transform: rotate(225deg);\n}\n\n.bsaDropDownMobile .Dropdown-menu {\n  background-color: white;\n  border: 1px solid #ccc;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  /* top:100%; */\n  width: initial;\n  overflow-wrap: break-word;\n  z-index: 1000;\n  -webkit-overflow-scrolling: touch;\n  text-align: left;\n}\n\n.bsaDropDownMobile .Dropdown-menu .Dropdown-group > .Dropdown-title {\n  padding: 8px 10px;\n  color: rgba(51, 51, 51, 1);\n  font-weight: bold;\n  text-transform: capitalize;\n}\n\n.bsaDropDownMobile .Dropdown-option {\n  box-sizing: border-box;\n  color: rgba(51, 51, 51, 0.8);\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bsaDropDownMobile .Dropdown-option:last-child {\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.bsaDropDownMobile .Dropdown-option:hover {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.bsaDropDownMobile .Dropdown-option.is-selected {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.bsaDropDownMobile .Dropdown-noresults {\n  box-sizing: border-box;\n  color: #ccc;\n  cursor: default;\n  display: block;\n  padding: 8px 10px;\n}\n\n.bsaDropDownMobile .Dropdown-placeholder {\n  height: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100px;\n  margin-left: 0px;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
